
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { SchoolMaster } from '../TitleList';
import { useDispatch, useSelector } from 'react-redux';
import { createSchoolEntry } from '../../Store/PHPSlice/School';
import SchoolTable from '../MasterTables/SchlTable/SchoolTable';
import { errorStyles } from '../../Utils/table';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const SchoolEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        firmId: '',
        schoolNm: '',
        adrs: '',
        contact: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    useEffect(() => {
        dispatch(fetchCompanyData());
    }, [dispatch])
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Handle numerical inputs for contactNo and accNo
        if (name === 'contact') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'contact' && value.length > 10) {
            return;
        }
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const validate = () => {
        const newErrors = {};
        if (!formData.schoolNm) newErrors.schoolNm = 'School Name is required';
        // if (!formData.firmId) newErrors.firmId = 'Firm is required';
        // if (!formData.contact) newErrors.contact = 'Contact No is required';
        // if (!formData.adrs) newErrors.adrs = 'Address is required';
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        dispatch(createSchoolEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("School Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const dropdownFirm = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.firmId
        }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };




    return (
        <>
            <Titlebar data={SchoolMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>School Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>
        
                                {/* {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                } */}

                                {[
                                    { label: 'School Name', name: 'schoolNm' },
                                    { label: 'Contact', name: 'contact' },
                                    { label: 'Address', name: 'adrs' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
                <SchoolTable />

            </div>
        </>
    );
}

export default SchoolEntry;
